import { styled } from '@mui/material';
/**
 * Renders its content into DOM in such a way that the content will not be visible on screen but will still be parsed
 * by a screen reader.
 *
 * For better a11y.
 * Useful e.g. for structural headings.
 */
export var ScreenReadersOnly = styled('div')({
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap' /* added line */,
  border: 0
});